import axios from 'axios';
import Cookies from 'js-cookie';

import { openModal } from '@help/modal.js';
import { validator400, validator400Plus } from '@utils/input_validator.js';
import { maskedTelInputs } from '@utils/masked_tel_inputs.js';
import { inputsCleanCrossHandler } from '@utils/inputs_with_clean_cross.js';


export function submitForm(callbackForm) {
  const errorTexts = callbackForm.querySelectorAll('.error-basic-text');
  const apiUrl = '/api/v1/callback/create/';
  const inputs = callbackForm.querySelectorAll('.form-input');
  const formData = {
    name: '',
    phone: ''
  };

  collectFormData();

  const csrfToken = Cookies.get('csrftoken');
  axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
  return axios.post(apiUrl, formData)
    .then(response => {
      const text = 'Your callback request has been successfully submitted.<br>We will contact you shortly!';
      openModal(text);
      cleanFormInputs(callbackForm);
    })
    .catch(error => {
      console.log('error', error)
      if (400 < error.response.status) {
        validator400Plus(inputs, errorTexts);
      } else {
        validator400(
          error.response.data.errors[0].state,
          inputs,
          errorTexts,
          false,
          true
        );
      };
    });

    function collectFormData() {
      inputs.forEach(input => {
        formData[input.name] = input.value;
      });
    };
  };

export async function callbackFormHandler() {
  const callbackForm = document.querySelector('.create-callback-form');
  if (callbackForm) {
    const submitButton = callbackForm.querySelector('.get-callback-btn');

    maskedTelInputs();
    inputsCleanCrossHandler();

    callbackForm.addEventListener('submit', function (e) {
      e.preventDefault();
    });

    submitButton.addEventListener('click', () => {
      submitButton.classList.add('disabled');

      submitForm(callbackForm);

      window.setTimeout(() => {
        submitButton.classList.remove('disabled');
      }, 3000);
    })
  }

}

export function cleanFormInputs(form) {
  const inputs = formf.querySelectorAll('.form-input');
  inputs.forEach(element => {
    element.value = '';
    element.nextElementSibling.classList.remove('has-content');
  });
}
